import CustomImage from './CustomImage'

export default CustomImage